import useSWR from 'swr';
import { fetcher } from '../services/fetcher';

export interface Invoice {
  invoiceId: number;
  clientId: number;
  InvoiceNo: string;
  InvoiceDate: string;
  invoiceDue?: string;
  invoiceAmount: number;
  invoiceVAT?: number;
  invoiceIncome?: number;
  invoiceType?: number;
  invoiceDescription?: string | null;
  client?: {
    clientName?: string;
  };
}

export interface InvoicesResponse {
  data: Invoice[];
  total: number;
  page: number;
  limit: number;
}

export const useInvoices = (searchParams?: string, filter?: string) => {
  const queryParams = new URLSearchParams();
  if (searchParams) queryParams.append('searchParams', searchParams);
  if (filter) queryParams.append('filter', filter);
  const queryString = queryParams.toString() ? `?${queryParams.toString()}` : '';

  const { data, error, isLoading, mutate } = useSWR<Invoice[]>(
    `/crm-clients-invoices${queryString}`,
    fetcher,
    {
      revalidateOnFocus: true,
      revalidateOnReconnect: true,
    }
  );

  // Ensure we always return an array, even if backend returns different format
  let invoices: Invoice[] = [];
  if (Array.isArray(data)) {
    invoices = data;
  } else if (data && typeof data === 'object') {
    // Handle case where backend returns { records: [...] } or { data: [...] }
    if ('records' in data && Array.isArray((data as any).records)) {
      invoices = (data as any).records;
    } else if ('data' in data && Array.isArray((data as any).data)) {
      invoices = (data as any).data;
    }
  }

  return {
    invoices,
    total: invoices.length,
    isLoading,
    isError: error,
    mutate,
  };
};

export const useInvoice = (id: number) => {
  const { data, error, isLoading, mutate } = useSWR<Invoice>(
    id ? `/crm-clients-invoices/${id}` : null,
    fetcher,
    {
      revalidateOnFocus: true,
    }
  );

  return {
    invoice: data,
    isLoading,
    isError: error,
    mutate,
  };
};

